import React from "react";
import styles from "@/styles/Ui.module.scss"
import clsx from "clsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";

interface Props {
    onClick?():void
    className?:string
    direction: "up" | "down" | "left" | "right"
    disabled?: boolean
    id?:string
}

const ChevroneBtn:React.FC<Props> = (props) => {
    
    const {
        onClick,
        className,
        direction,
        disabled,
        id
    } = props
    
    return (
        <button
            id={id && id}
            disabled={disabled}
            onClick={onClick}
            aria-label={"chv_btn"}
            className={clsx(
                styles.chevrone_btn,
                className && className,
                styles[direction]
            )}
        >
            <ChevroneIcon />
        </button>
    )
}

export default ChevroneBtn